import React from 'react';
import styled from '@emotion/styled';
import dynamic from 'next/dynamic';
import { Trans } from 'next-i18next';
import ExternalLink from 'src/components/ExternalLink';
import { EVENT_NAME, EVENT_TYPE } from 'src/types/Event';
import { VipBenefit } from 'src/types/VIP';
import { pushEvent } from 'src/utils/event-gateway';
import { hoverAndActiveCss } from 'src/utils/styled';
const Green = styled.span`
  color: #18da9e;
`;
const Row = styled(ExternalLink)`
  display: flex;
  align-items: center;
  flex-direction: row;
  cursor: pointer;
  text-decoration: none;

  ${({
  theme
}) => hoverAndActiveCss(`
    background-color: ${theme.color.surface4};
  `)}
`;

// Rtl 위해서 margin 대신 pad 컴포넌트이용
const RowPadOne = styled.div`
  min-width: 12px;
`;
const RowPadTwo = styled.div`
  min-width: 16px;
`;
const RowIconWrap = styled.div`
  display: inline-flex;
  padding: 8px;
  border-radius: 16px;
  background-color: ${({
  theme
}) => theme.color.surface4};
`;
const RowIcon = styled.img`
  width: 40px;
  height: 40px;
`;
const RowBtn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 16px;
  width: 16px;
  box-sizing: border-box;
`;
const RowWrap = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;
const RowSubTitle = styled.div`
  font-size: 12px;
  line-height: 14px;
  margin-bottom: 4px;
  color: ${({
  theme
}) => theme.color.content9};
`;
const RowTitle = styled.div`
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  color: ${({
  theme
}) => theme.color.content11};
`;
const IcChevronRight = styled(dynamic(() => import('src/assets/images/icChevronRight.svg')))`
  ${({
  theme
}) => theme.isRtl && 'transform: scaleX(-1);'}
  fill: ${({
  theme
}) => theme.color.content7};
  width: 16px;
  height: 16px;
`;
export interface BenefitProps extends VipBenefit {
  rating: string;
  isUpperRating: boolean;
}
const Benefit: React.FC<BenefitProps> = ({
  rating,
  title,
  subTitle,
  iconUrl,
  deeplink
}) => {
  const handleClickHref: React.MouseEventHandler<HTMLAnchorElement> = () => {
    if (!deeplink) {
      return;
    }
    pushEvent({
      eventType: EVENT_TYPE.VIP,
      eventName: EVENT_NAME.VIP_SYSTEM__CLICK_BUTTON,
      eventParams: {
        grade: rating,
        deeplink
      }
    });
  };
  return <Row href={deeplink} onMouseDown={handleClickHref} data-sentry-element="Row" data-sentry-component="Benefit" data-sentry-source-file="Benefit.tsx">
      <RowIconWrap data-sentry-element="RowIconWrap" data-sentry-source-file="Benefit.tsx">
        <RowIcon src={iconUrl} alt='Benefit Gem' data-sentry-element="RowIcon" data-sentry-source-file="Benefit.tsx" />
      </RowIconWrap>
      <RowPadOne data-sentry-element="RowPadOne" data-sentry-source-file="Benefit.tsx" />
      <RowWrap data-sentry-element="RowWrap" data-sentry-source-file="Benefit.tsx">
        <RowSubTitle data-sentry-element="RowSubTitle" data-sentry-source-file="Benefit.tsx">{subTitle}</RowSubTitle>
        <RowTitle data-sentry-element="RowTitle" data-sentry-source-file="Benefit.tsx">
          <Trans defaults={title} components={{
          Green: <Green />
        }} data-sentry-element="Trans" data-sentry-source-file="Benefit.tsx">
            {title}
          </Trans>
        </RowTitle>
      </RowWrap>
      <RowPadTwo data-sentry-element="RowPadTwo" data-sentry-source-file="Benefit.tsx" />
      {deeplink && <RowBtn>
          <IcChevronRight />
        </RowBtn>}
    </Row>;
};
export default Benefit;